<!--
// app/pages/[region]/Regulation.vue
-->
<script setup lang="ts">
import type { Regulation } from "~/src/content/domain/models/Regulation";
import BaseNuxtLink from "~/app/components/base/baseNuxtLink.vue";
import { useCompetitionStore } from "~/app/stores/competitionStore";
import regulationUiService from "~/src/content/infrastructure/ui-services/regulationUiService";

const { t, locale } = useI18n();
const { region } = useCompetitionStore();
const { getRegulationPdf } = regulationUiService();

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: "/[region]/regulation",
    es: "/[region]/reglamento",
    de: "/[region]/regeln",
    fr: "/[region]/reglement",
    it: "/[region]/regolamento",
    pt: "/[region]/regulamento",
  },
});

definePageMeta({
  middleware: ["not-found-king-of-kings-nations"],
});

useSeoMeta({
  title: t("regulation.title"),
  ogTitle: t("regulation.title"),
});

const leagueName = region?.leagueTitle || "";
const regulationPdf = ref<Regulation>();

regulationPdf.value = await getRegulationPdf(locale.value);
</script>

<template>
  <section class="py-9 px-6 md:py-24 max-w-4xl md:mx-auto">
    <h1 class="text-gray-300 text-2xl leading-9 mb-4">{{ $t("regulation.title") }}</h1>
    <i18n-t keypath="regulation.description" tag="p" class="text-xl font-bold mb-12 md:mb-24">
      <template #leaguePatro>
        <span>{{ leagueName }}</span>
      </template>
    </i18n-t>
    <base-nuxt-link
      v-if="regulationPdf"
      :title="regulationPdf.title"
      :to="regulationPdf.pdfLink"
      target="_blank"
      emphasis
      text-size="text-sm font-medium"
      >{{ $t("regulation.button") }}</base-nuxt-link
    >
  </section>
</template>

<style scoped></style>
